export default __webpack_public_path__ + "static/media/error-page-404.bbe41ab9.png";